import { memo } from 'react';
import { useAuthCheckAccess, useAuthCheckRealmRole } from '@aibees/shared/auth';
import { Navigate } from 'react-router-dom';
import { ProtectedRouteProps as Props } from './types';

export const ProtectedRoute = memo(({ roles, realmRoles, children }: Props) => {
  const rolesCheck = useAuthCheckAccess(roles, true);
  const realmRolesCheck = useAuthCheckRealmRole(realmRoles, true);
  const allowed = rolesCheck && realmRolesCheck;

  return allowed ? children : <Navigate to="/home" replace />;
});

ProtectedRoute.displayName = 'ProtectedRoute';
